import { switchUserTournament } from 'modules/auth/store/actions';
import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import { mapPayloadToUpsertInput } from 'modules/organizer/domain/data-mappers/organizer-upsert.mapper';
import { Organizer } from 'modules/organizer/domain/interfaces/organizer';
import { OrganizerUpsertPayload } from 'modules/organizer/domain/interfaces/organizer-upsert-payload';
import { upsertOrganizer } from 'modules/organizer/store/orginizer/actions';
import { OrganizerForm } from 'modules/organizer/ui/components/organizer-form';
import { useEffect } from 'react';
import UDHeaderTitle from 'ud-ui/components/header-title';
import UDText from 'ud-ui/components/text';
import { useMainLayout } from 'ud-ui/layout/main/context';
import { useAppDispatch } from 'store/hooks';

const OrganizerCreatePage = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuth();
  const { setHeaderContent } = useMainLayout();
  const initData = { phone: user?.phone } as Organizer;

  const createOrganizer = (data: OrganizerUpsertPayload) => {
    const params = mapPayloadToUpsertInput(data, user!.id);

    dispatch(upsertOrganizer(params))
      .unwrap()
      .then((result) => dispatch(switchUserTournament(result.id)));
  };

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Создание организатора</UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return (
    <>
      <div className="w-full px-6 py-6">
        <UDText type="headline" className="mr-10">
          Информация об организаторе
        </UDText>
      </div>
      <div className="border-surfacePlatinum20 flex w-full items-center border-b px-6" />
      <div className="w-full px-6 py-6">
        <OrganizerForm onSubmit={createOrganizer} initialValues={initData} />
      </div>
    </>
  );
};

export default OrganizerCreatePage;
